var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9675 10.685L10.92 5.7325L10.115 4.945L5.9675 9.0925L3.8675 6.9925L3.08 7.78L5.9675 10.685ZM7 14.5C6.04333 14.5 5.13917 14.3162 4.2875 13.9488C3.43583 13.5813 2.69208 13.0796 2.05625 12.4438C1.42042 11.8079 0.91875 11.0642 0.55125 10.2125C0.18375 9.36083 0 8.45667 0 7.5C0 6.53167 0.18375 5.62167 0.55125 4.77C0.91875 3.91833 1.42042 3.1775 2.05625 2.5475C2.69208 1.9175 3.43583 1.41875 4.2875 1.05125C5.13917 0.68375 6.04333 0.5 7 0.5C7.96833 0.5 8.87833 0.68375 9.73 1.05125C10.5817 1.41875 11.3225 1.9175 11.9525 2.5475C12.5825 3.1775 13.0813 3.91833 13.4488 4.77C13.8162 5.62167 14 6.53167 14 7.5C14 8.45667 13.8162 9.36083 13.4488 10.2125C13.0813 11.0642 12.5825 11.8079 11.9525 12.4438C11.3225 13.0796 10.5817 13.5813 9.73 13.9488C8.87833 14.3162 7.96833 14.5 7 14.5ZM7 13.45C8.65667 13.45 10.0625 12.8696 11.2175 11.7087C12.3725 10.5479 12.95 9.145 12.95 7.5C12.95 5.84333 12.3725 4.4375 11.2175 3.2825C10.0625 2.1275 8.65667 1.55 7 1.55C5.355 1.55 3.95208 2.1275 2.79125 3.2825C1.63042 4.4375 1.05 5.84333 1.05 7.5C1.05 9.145 1.63042 10.5479 2.79125 11.7087C3.95208 12.8696 5.355 13.45 7 13.45Z",
    fill: "#2DB377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipComplete);
export default __webpack_public_path__ + "static/media/chip-complete.1624f2208f6878b4fb6261cf22cde795.svg";
export { ForwardRef as ReactComponent };